import size from 'lodash.size';
import { T, always, anyPass, complement, cond, equals, gt, isNil, pipe, test } from 'ramda';
import toPairs from 'ramda/es/toPairs';

import { FormValue } from 'types/index';

// While this works, it isn't a complete implementation
// It lacks support for nested objects to keep things simple,
// but a complete implementation probably would look like this:
// https://stackoverflow.com/a/49388446
// TODO:: remove and use a package instead

export const convertToFormData = (obj: Record<string, FormValue>): FormData => {
  const formData = new FormData();

  toPairs(obj).forEach(([fieldName, fieldValue]) => {
    if (Array.isArray(fieldValue)) {
      fieldValue.forEach((value: any, index: number) => {
        formData.append(`${fieldName}[${index}]`, value);
      });
    } else if (fieldValue) {
      formData.append(fieldName, fieldValue);
    }
  });

  return formData;
};

export function splitFileFromFormData<T extends Record<string, unknown>>(
  obj: T,
  fileKey: keyof T,
  formDataKey: string,
  outputFileKey?: string
): FormData {
  const formData = new FormData();

  const { [fileKey]: file, ...rest } = obj;

  if (file && typeof file !== 'string') {
    formData.append(String(outputFileKey || fileKey), file as Blob);
  }

  formData.append(formDataKey, JSON.stringify(rest));

  return formData;
}

export const isEmailValid = (email: string): boolean => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
interface ErrorMessage {
  message: string;
  values?: Record<string, unknown>;
}

const buildErrorMessage = (message: string, values?: Record<string, unknown>): ErrorMessage => ({
  message,
  values,
});

const isNotPresent = anyPass([isNil, equals('')]);

const hasNumbers: (value: string) => boolean = test(/\d/);

const lengthSatisfies = (fn: (a: any) => boolean) => pipe(size, fn);

const hasLowerCaseCharacters = test(/[a-z]/);

const hasUpperCaseCharacters = test(/[A-Z]/);

export const createPasswordValidator = (minLength: number): ((value: string) => ErrorMessage) =>
  cond([
    [isNotPresent, always(undefined)],
    [
      lengthSatisfies(gt(minLength)),
      always(buildErrorMessage('error.validation.password.wrong-length', { minimumLength: minLength })),
    ],
    [complement(hasNumbers), always(buildErrorMessage('error.validation.password.no-numbers'))],
    [complement(hasLowerCaseCharacters), always(buildErrorMessage('error.validation.password.no-lowercase-letters'))],
    [complement(hasUpperCaseCharacters), always(buildErrorMessage('error.validation.password.no-uppercase-letters'))],
    [T, always(undefined)],
  ]);

export const removePlaceholderMask = (value: string): string => value.replace(/_/g, '');

// TODO:: verify why libphonenumber-js returns error when CO number is 574561111 for example
export const isValidCOPhone = (rawPhone: string): boolean => {
  if (rawPhone.length === 8 || rawPhone.length === 9 || rawPhone.length === 10) {
    return true;
  }

  return false;
};

export const formatSlug = (shName: string): string => {
  const formattedSlug = shName
    .replace(/[^a-z- ]/gi, '')
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/\s/g, '-')
    .replace(/-+/gi, '-');

  const slugReturns = formattedSlug.slice(0, 20).toLowerCase();

  const getLastCharacter = slugReturns.slice(-1);

  if (getLastCharacter === '-') {
    return slugReturns.replace(/.$/, '');
  }

  return slugReturns;
};
